module.exports = __webpack_public_path__ + "static/about-page-hero-bottom-img-edd5c5aefc71a0d3865532f7c4c2e5fb.png";